import { render, staticRenderFns } from "./SubscriptionReceipt.vue?vue&type=template&id=951d583e&scoped=true"
import script from "./SubscriptionReceipt.vue?vue&type=script&lang=js"
export * from "./SubscriptionReceipt.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionReceipt.vue?vue&type=style&index=0&id=951d583e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951d583e",
  null
  
)

export default component.exports